import { useEffect } from 'react';

/**
 * Хук для установки заголовка вкладки и robots noindex на админских страницах.
 * Возвращает функцию очистки, чтобы публичный сайт не получил noindex.
 */
export function useAdminMeta(title) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} · Кабинет Светланы` : 'Кабинет Светланы';

    let robots = document.querySelector('meta[name="robots"]');
    const created = !robots;
    const prevRobots = robots ? robots.getAttribute('content') : null;
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', 'noindex, nofollow, noarchive, noimageindex');

    return () => {
      document.title = prevTitle;
      if (created && robots && robots.parentNode) {
        robots.parentNode.removeChild(robots);
      } else if (robots && prevRobots != null) {
        robots.setAttribute('content', prevRobots);
      }
    };
  }, [title]);
}
